module.exports = __webpack_public_path__ + "static/media/COLA2018007.5c55ff5c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles/COLA2018007.pdf
// module id = 2576
// module chunks = 1